import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { SidenavService } from '@core/services/sidenav.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogEquipmentService } from './dialog/dialog-equipments.service';
import { FilterEquipmentsComponent } from './filter/filter-equipments.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { EquipmentsService } from './services/equipments-resolver.service';
var EquipmentsComponent = /** @class */ (function () {
    function EquipmentsComponent(fuseTranslationLoaderService, authenticationService, equipmentsService, matDialog, dialogEquipmentService, sidenavService) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.authenticationService = authenticationService;
        this.equipmentsService = equipmentsService;
        this.matDialog = matDialog;
        this.dialogEquipmentService = dialogEquipmentService;
        this.sidenavService = sidenavService;
        this.equipments = [];
        this.displayedColumns = ['number', 'name', 'typeName', 'locationName', 'locationEnvironmentName', 'warrantyStatus', 'warrantyStartDate', 'warrantyEndDate', 'createdAt', 'edit'];
        this.filtered = false;
        this.loading = true;
        this.subscriptions = new Subject();
        this.equipmentsReload = new Subject();
        this.hasEditEquipmentPermission = this.authenticationService.hasPermission('equipments-edit');
        this.hasCreateEquipmentPermission = this.authenticationService.hasPermission('equipments-create');
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.hasCreateWarrantiesPermission = this.authenticationService.hasPermission('warranties-create');
        this.updateListener = function (event) {
            _this.reload();
        };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    EquipmentsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.loading = true;
                this.sort.active = 'name';
                this.sort.direction = 'asc';
                merge(this.sort.sortChange, this.paginator.page, this.filterEquipmentsComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.equipmentsReload)
                    .pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
                    _this.sort.direction = _this.sort.direction || 'asc';
                    var options = {
                        orderBy: _this.sort.active + "_" + _this.sort.direction,
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    _this.loading = true;
                    return _this.equipmentsService.loadData({
                        where: _this.filterEquipmentsComponent.filterChanged.value,
                        options: options
                    });
                }))
                    .subscribe(function (result) {
                    _this.datatable.nativeElement.scrollTo({
                        top: 0
                    });
                    _this.equipments = result.items;
                    _this.totalCount = result.totalCount;
                    _this.filtered = result.filtered;
                    _this.loading = false;
                });
                window.addEventListener('updateWarranty', this.updateListener);
                return [2 /*return*/];
            });
        });
    };
    EquipmentsComponent.prototype.reload = function () {
        this.equipmentsReload.next();
    };
    EquipmentsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
        window.removeEventListener('updateWarranty', this.updateListener);
    };
    EquipmentsComponent.prototype.openDialog = function (equipmentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialogEquipmentService.open({
                            equipmentId: equipmentId
                        })];
                    case 1:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.equipmentsReload.next();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentsComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterEquipmentsComponent.clearFilters();
    };
    EquipmentsComponent.prototype.openExportDialog = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.equipments,
                limit: 10000,
                total: this.totalCount,
                where: this.filterEquipmentsComponent.filterChanged.value
            }
        });
    };
    return EquipmentsComponent;
}());
export { EquipmentsComponent };
